import type { PublicTrip } from "@busbud/core-types/dist/lib/poll-service/api";

import type { LegIndex } from "@app/constants/trip";
import { OUTBOUND_LEG_INDEX, RETURN_LEG_INDEX } from "@app/constants/trip";

import {
  getOutboundDepartureInternationalTime,
  getReturnDepartureInternationalTime
} from "./get-departure-time";
import { isInFutureFromNow } from "./international-time";
import { isRoundtrip } from "./is-roundtrip";
import { throwsIfAccessingReturnLegOfOnewayTrip } from "./leg-access-guard";

export function hasUpcomingOutbound(trip: PublicTrip): boolean {
  return hasUpcomingLeg(trip, OUTBOUND_LEG_INDEX);
}

export function hasUpcomingReturn(trip: PublicTrip): boolean {
  if (!isRoundtrip(trip)) {
    throw new Error("the trip is not a roundtrip");
  }
  return hasUpcomingLeg(trip, RETURN_LEG_INDEX);
}

function hasUpcomingLeg(trip: PublicTrip, leg_idx: LegIndex): boolean {
  throwsIfAccessingReturnLegOfOnewayTrip(trip, leg_idx);

  const getDepartureInternationalTime =
    leg_idx === 0
      ? getOutboundDepartureInternationalTime
      : getReturnDepartureInternationalTime;

  return isInFutureFromNow(getDepartureInternationalTime(trip));
}
